var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123 478L123 506",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 123.5,
    cy: 473.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.105 482C119.637 482 119.236 481.834 118.903 481.501C118.57 481.168 118.403 480.768 118.403 480.3C118.403 479.833 118.57 479.432 118.903 479.099C119.236 478.766 119.637 478.6 120.105 478.6C120.573 478.6 120.973 478.766 121.306 479.099C121.64 479.432 121.806 479.833 121.806 480.3C121.806 480.768 121.64 481.168 121.306 481.501C120.973 481.834 120.573 482 120.105 482ZM128.613 482C128.145 482 127.744 481.834 127.411 481.501C127.078 481.168 126.911 480.768 126.911 480.3C126.911 479.833 127.078 479.432 127.411 479.099C127.744 478.766 128.145 478.6 128.613 478.6C129.081 478.6 129.481 478.766 129.814 479.099C130.148 479.432 130.314 479.833 130.314 480.3C130.314 480.768 130.148 481.168 129.814 481.501C129.481 481.834 129.081 482 128.613 482ZM119.382 468.4L121.423 472.65H127.379L129.719 468.4H119.382ZM118.573 466.7H131.122C131.449 466.7 131.697 466.845 131.867 467.136C132.037 467.426 132.044 467.72 131.888 468.018L128.868 473.457C128.712 473.741 128.503 473.96 128.24 474.116C127.978 474.272 127.691 474.35 127.379 474.35H121.041L120.105 476.05H130.314V477.75H120.105C119.467 477.75 118.985 477.47 118.658 476.911C118.332 476.351 118.318 475.795 118.616 475.242L119.764 473.16L116.702 466.7H115V465H117.765L118.573 466.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.7d0bbb78c6bf9f9ae3f5e56d66026169.svg";
export { ForwardRef as ReactComponent };